module.exports = __webpack_public_path__ + "img/1.997001e9.png";